import { useMutation } from '@tanstack/react-query'
import { assignCustomerFeeWallet } from 'services/CustomerService'
import { AssignCustomerFeeWalletPayload } from 'types/customers'

export const useAssignCustomerFeeWalletMutation = () => {
  return useMutation({
    mutationFn: (payload: AssignCustomerFeeWalletPayload) => assignCustomerFeeWallet(payload),
  })
}
